import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";
import type { AnalyticsPeriod } from "@/lib/api";

interface PeriodSelectorProps {
  period: AnalyticsPeriod;
  onPeriodChange: (period: AnalyticsPeriod) => void;
  onRefresh: () => void;
  isLoading?: boolean;
}

const periods: { value: AnalyticsPeriod; label: string }[] = [
  { value: '7d', label: '7 Days' },
  { value: '30d', label: '30 Days' },
  { value: '90d', label: '90 Days' },
];

export function PeriodSelector({
  period,
  onPeriodChange,
  onRefresh,
  isLoading,
}: PeriodSelectorProps) {
  return (
    <div className="flex items-center gap-2">
      <div className="flex rounded-lg border">
        {periods.map((p) => (
          <Button
            key={p.value}
            variant={period === p.value ? "default" : "ghost"}
            size="sm"
            className="rounded-none first:rounded-l-lg last:rounded-r-lg"
            onClick={() => onPeriodChange(p.value)}
          >
            {p.label}
          </Button>
        ))}
      </div>
      <Button
        variant="outline"
        size="sm"
        onClick={onRefresh}
        disabled={isLoading}
      >
        <RefreshCw className={`h-4 w-4 mr-2 ${isLoading ? 'animate-spin' : ''}`} />
        Refresh
      </Button>
    </div>
  );
}
